import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiInfoCircle } from "react-icons/bi";
import { Jutsu } from "react-jutsu";
import { toast } from "react-toastify";
import Get from "../../api/Get";
import Put from "../../api/Put";
import { APPOINTMENT_UPDATE, GET_APPOINTMENT_BY_ID } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";
import { getStrTipoDoctor } from "../../utils/getStrTipoDoctor";
import { isConsultorio } from "../../utils/isConsultorio";
import { setTimeAppointment } from "../../utils/setTimeAppointment";
import CountdownComponent from "../CountdownComponent";
import CardActionMedicalColombia from "./CardActionMedicalColombia";
import CardActionMedicalMexico from "./CardActionMedicalMexico";
import CardActionRightMedicalColombia from "./CardActionRightMedicalColombia";
import CardActionRightMedicalMexico from "./CardActionRightMedicalMexico";
import CardDataClientColombia from "./CardDataClientColombia";
import CardDataClientMexico from "./CardDataClientMexico";
import FormExtraTime from "./FormExtraTime";

function DoctorEnCita({ t, cita, setCita, onComplete, handleAPI, companyType, handleShowEditData, setShowSuccess, setShowModalServer, setErrorServer,
    setShowEncuesta, handleShowEditDataMexico, noComienza, showEncuesta, showBtnConsultaFallida, setShowBtnConsultaFallida, isJoinedPatient,
    reload, setReload, setOpenConsentimiento, validDiagnostico, setValidDiagnostico }) {
    const [startMeeting, setStartMeeting] = useState(null)
    const [serverTime, setServerTime] = useState(null)
    const [clientTime, setClientTime] = useState(null)
    const [isTime, setIsTime] = useState(true)
    const [almostDown, setIsAlmostDown] = useState(false)
    const [showExtreTime, setShowExtraTime] = useState(false)
    const [minutsTotal, setMinutsTotal] = useState(0)
    const { auth } = useContext(authContext)

    //test
    const [checkingCF, setCheckingCF] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const handleClose = () => {
        setShowModal(false)
    }

    //extra time
    const [showFormET, setShowFormET] = useState(false)
    const showFormExtraTime = (show) => {
        setShowFormET(show)
    }

    const scrollRef = useRef()

    useEffect(() => {
        //console.log(cita)
        //let min = cita.scheduleDTO.minutesAppointment
        let minToPlus = 0

        let serverTime = moment(cita.currentTime, "DD/MM/YYYY HH:mm:ss")
        let startAppointment = moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss")

        let endAppointment = moment(cita.scheduleDTO.dateTimeEnd, "YYYY-MM-DDTHH:mm:ss")
        let diffMinuts = endAppointment.diff(startAppointment, "minutes")
        setMinutsTotal(diffMinuts)

        if (serverTime.isBefore(startAppointment)) {
            let diff = startAppointment.diff(serverTime, "seconds")
            //console.log(diff)
            //min-=diff
            minToPlus = diff
        }
        minToPlus *= 1000

        setClientTime(Date.now())
        setServerTime(moment(cita.currentTime, "DD/MM/YYYY HH:mm:ss").valueOf() + minToPlus)
        setStartMeeting(moment(cita.scheduleDTO.dateTimeEnd, "YYYY-MM-DDTHH:mm:ss").valueOf())
    }, [])

    //efecto para aumentar los minutos
    const [newEndDate, setNewEndDate] = useState(null)
    useEffect(() => {
        //console.log('entro agrgar end time')
        //console.log(newEndDate)
        if (newEndDate !== null) {
            setStartMeeting(moment(newEndDate, "YYYY-MM-DDTHH:mm").valueOf())
            setNewEndDate(null)
        }
    }, [newEndDate])

    const showModalfallida = () => {
        setShowModal(true)
    }
    const [isSubmitingFallida, setIsSubimitingfallida] = useState(false)
    const citaFallida = () => {
        setIsSubimitingfallida(true)
        let d = {
            id: cita.id,
            appointmentStatus: 'Fallida',
            videoCalls: [{
                id: '',
                initVideo: false,
                userType: 'Doctor'
            }]
        }

        Put({ url: APPOINTMENT_UPDATE, data: d, access_token: auth.data.access_token, header: true })
            .then(response => {
                if (response.data.state) {
                    setIsSubimitingfallida(false)
                    setShowModal(false)
                    onComplete();
                } else {
                    setIsSubimitingfallida(false)
                    //toast.info(response.data.error.message, {autoClose: 8000})
                }
            })
            .catch(error => {
                console.log(error)
                toast.error("No se puede ejecutar esta acción. Intente más tarde", { autoClose: 8000 })
            })

    }

    const finalizarConsultaByConsultorio = () => {
        setTimeAppointment(cita.id, 'Doctor', false, cita.dataVideoCallList, auth)
        if (companyType === 'colombia' && isConsultorio(auth.data.role)) {
            Get({
                url: `${GET_APPOINTMENT_BY_ID}/${cita.id}`,
                access_token: auth.data.access_token,
            })
                .then((response) => {
                    if (response.data.data && setCita) {
                        setCita(response.data.data)
                    }
                })
                .catch(() => {})
                .finally(() => {
                    if (setReload) {
                        setReload(true)
                    }
                })
        }
        setShowEncuesta(true)
    }
    const [showInit, setShowInit] = useState(true)
    const iniciarConsultaByConsultorio = () => {
        setTimeAppointment(cita.id, 'Doctor', true, cita.dataVideoCallList, auth)
        setShowInit(false)
    }

    return (
        <Row>
            <Col xs="12" md="6" className="overflow-y-auto h-scrollbar h-100vh order-2 order-md-1" ref={scrollRef}>
                <Card className={`shadow-1 ${almostDown ? 'bg-red-light' : 'bg-blue-light'}`}>
                    <Card.Body>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h6 className={`mb-0 ${almostDown ? 'text-white' : 'text-blue-2'}`}>{t('cita_comenzado')}</h6>
                            </div>
                            <div>
                                <h6 className={`mb-0 ${almostDown ? 'text-white' : 'text-blue-2'}`}>
                                    {startMeeting && <CountdownComponent
                                        date={startMeeting}
                                        serverTime={serverTime}
                                        setServerTime={setServerTime}
                                        clientTime={clientTime}
                                        setClientTime={setClientTime}
                                        onComplete={onComplete}
                                        setIsTime={setIsTime}
                                        setIsAlmostDown={setIsAlmostDown}
                                        setShowExtraTime={setShowExtraTime}

                                        minutsTotal={minutsTotal}
                                        setShowBtnConsultaFallida={setShowBtnConsultaFallida}
                                        checkingCF={checkingCF}
                                        setCheckingCF={setCheckingCF}
                                    />}
                                </h6>
                            </div>
                        </div>
                        {
                            showExtreTime &&
                            <div>
                                <label className="font-size-08rem text-white my-2 border-bottom d-block text-center">
                                    <BiInfoCircle /> Faltan menos de 5 min. para terminar la consulta
                                </label>
                                <div className="d-flex text-white align-items-center mt-2 justify-content-around">
                                    <div>
                                        <label>¿Deseas agregar tiempo?</label>
                                    </div>
                                    <div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio"
                                                name="extraTime"
                                                value="si"
                                                onChange={e => showFormExtraTime(true)}
                                            />
                                            <label className="form-check-label">{t('Si')}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio"
                                                name="extraTime"
                                                value="no"
                                                onChange={e => showFormExtraTime(false)}
                                            />
                                            <label className="form-check-label">{t('No')}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Card.Body>
                </Card>
                <FormExtraTime idCita={cita.id}
                    setIsAlmostDown={setIsAlmostDown}
                    setShowExtraTime={setShowExtraTime}
                    setShowFormET={setShowFormET}
                    showFormET={showFormET}
                    setNewEndDate={setNewEndDate}
                />
                {
                    companyType === 'colombia' ?
                        <CardDataClientColombia
                            cita={cita}
                            setShowSuccess={setShowSuccess}
                            handleShowEditData={handleShowEditData}
                            setShowModalServer={setShowModalServer}
                            setErrorServer={setErrorServer}
                            setOpenConsentimiento={setOpenConsentimiento}
                        /> :
                        <CardDataClientMexico cita={cita} setShowSuccess={setShowSuccess} handleShowEditDataMexico={handleShowEditDataMexico} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} noComienza={noComienza} setReload={setReload} />
                }
                {
                    companyType === 'colombia' ?
                        <CardActionMedicalColombia cita={cita} setCita={setCita} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} validDiagnostico={validDiagnostico} scrollRef={scrollRef}
                            reload={reload} setReload={setReload} /> :
                        <CardActionMedicalMexico cita={cita} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} setShowSuccess={setShowSuccess} setReload={setReload} />
                }
            </Col>
            <Col xs="12" md="6" className="order-1 order-md-2">
                {
                    !isConsultorio(auth.data.role) &&
                    <>
                        <Row>
                            <Col>
                                <Jutsu
                                    roomName={(cita && cita.token_conference) ? cita.token_conference : "No se pudo establecer la conexión de la videollamada"}
                                    domain={cita?.url_conference}
                                    subject={`${getStrTipoDoctor(Number(cita.speciality.id))}: ${cita.scheduleDTO.name_doctor}`}
                                    displayName={cita.scheduleDTO.name_doctor ? `${cita.scheduleDTO.name_doctor}` : "nombre_doctor"}
                                    userName={cita.scheduleDTO.name_doctor ? `${cita.scheduleDTO.name_doctor}` : "nombre_doctor"}
                                    loadingComponent={<p> {t('inicia_cita')} </p>}
                                    onMeetingEnd={e => setShowEncuesta(true)}
                                    errorComponent={
                                        companyType === "colombia" ?
                                            <p> {t('error_componente_jitsi_colombia')} </p> :
                                            <p> {t('error_componente_jitsi_mexico')} </p>
                                    }
                                    onJitsi={handleAPI}
                                    // onJitsi={(handleAPI) => {
                                    //     handleAPI.addListener("participantJoined", (data) => {
                                    //         const participants = handleAPI.getNumberOfParticipants();
                                    //         //console.log(participants);
                                    //         if (participants >= 2) {
                                    //             handleAPI.executeCommand('startRecording', { mode: "file" });
                                    //         }
                                    //     });
                                    // }}
                                    containerStyles={{ width: '100%', height: '400px', margin: 'auto' }}
                                    jwt={cita?.scheduleDTO?.jwtDoctor}
                                />
                            </Col>
                        </Row>

                        {
                            showBtnConsultaFallida &&
                            <div className="text-center">
                                <Button type="button" variant="primary" className="py-2 px-3 my-3" onClick={showModalfallida}>Consulta fallida</Button>
                            </div>
                        }
                    </>
                }

                {
                    (isConsultorio(auth.data.role) && companyType === 'colombia') &&
                    <>
                        <div className="text-center">
                            {showInit && <Button type="button" variant="primary" className="py-2 px-3 my-3 mr-2" onClick={iniciarConsultaByConsultorio}>Iniciar consulta</Button>}
                            {!showInit &&
                                <>
                                    <Button type="button" variant="danger" className="py-2 px-3 my-3 mr-2" onClick={finalizarConsultaByConsultorio}>Finalizar consulta</Button>
                                    <Button type="button" variant="secondary" className="py-2 px-3 my-3" onClick={showModalfallida}>Consulta fallida</Button>
                                </>
                            }
                        </div>
                    </>
                }

                <Row className="mb-3">
                    <Col>
                        {
                            companyType === 'colombia' ?
                                <CardActionRightMedicalColombia cita={cita} setValidDiagnostico={setValidDiagnostico} showEncuesta={showEncuesta} /> :
                                <CardActionRightMedicalMexico cita={cita} />
                        }
                    </Col>
                </Row>
            </Col>
            <Modal show={showModal} onHide={handleClose}>
                {isSubmitingFallida && <SimpleLoad />}
                <Modal.Header closeButton>
                    <h6>Cita</h6>
                </Modal.Header>
                <Modal.Body>
                    {
                        isJoinedPatient ?
                            <label>No puede seleccionar esta cita como fallida ya que el paciente ya realizo conexión a la misma</label> :
                            <label>¿Está seguro que desea reportar la cita como fallida?, una vez acepte no podrá modificar los documentos de la cita actual</label>
                    }




                    <Row className="mt-3">
                        <Col xs="12" md="12" className="text-right">
                            {!isJoinedPatient && <Button type="button" variant="secondary" className="btn1" onClick={handleClose}>Cancelar</Button>}{' '}
                            <Button type="button" variant="primary" className="btn1" onClick={isJoinedPatient ? handleClose : citaFallida}>Aceptar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </Row>
    )
}

export default withTranslation()(DoctorEnCita)